module.exports = __webpack_public_path__ + "static/media/mnisky2.f8ef4618.JPG";